import { render, staticRenderFns } from "./ClientWorkFromAreas.vue?vue&type=template&id=0a9e1b50&"
import script from "./ClientWorkFromAreas.vue?vue&type=script&lang=js&"
export * from "./ClientWorkFromAreas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports